import React from 'react';
import { Text, Box, IconQuoteOpen40 } from '@stitch-fix/mode-react';
import styles from './styles.module.scss';

interface Testimonial {
  quote: string;
  source: string;
  role?: string;
}

export type TestimonialsProps = {
  testimonials: Testimonial[];
};

export const Testimonials = ({ testimonials }: TestimonialsProps) => {
  return (
    <Box className={styles.container}>
      {testimonials.map(testimonial => (
        <Box key={testimonial.quote} className={styles.testimonial}>
          <blockquote>
            <Text setting="body-small">
              <IconQuoteOpen40
                title="Quotation Mark"
                color="mint-60"
                className={styles.quoteIcon}
              />
              {testimonial.quote}
            </Text>
            <Text as="cite" setting="body-medium-fixed">
              <strong>{testimonial.source}</strong>
              {testimonial.role && (
                <strong className={styles.role}>{testimonial.role}</strong>
              )}
            </Text>
          </blockquote>
        </Box>
      ))}
    </Box>
  );
};
